import avatar1 from '../../img/avatar/1.png';
import avatar2 from '../../img/avatar/2.png';
import avatar3 from '../../img/avatar/3.png';
import avatar4 from '../../img/avatar/4.png';
import avatar5 from '../../img/avatar/5.png';
import avatar6 from '../../img/avatar/6.png';
import avatar7 from '../../img/avatar/7.png';
import avatar8 from '../../img/avatar/8.png';
import avatar9 from '../../img/avatar/9.png';
import avatar10 from '../../img/avatar/10.png';
import avatar11 from '../../img/avatar/11.png';
import avatar12 from '../../img/avatar/12.png';

let avatars = [
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  avatar10,
  avatar11,
  avatar12,
];
export default avatars;



// WEBPACK FOOTER //
// ./src/img/avatar/Avatar.js